<template>
  <!-- Estado -->
  <div class="block-badges">
    <b-badge v-show="oferta.ganada" variant="success"> &laquo;Ganada&raquo; {{ fechaGanada }} </b-badge>
    <b-badge v-show="oferta.perdida" variant="danger"> &laquo;Perdida&raquo; {{ fechaPerdida }} </b-badge>
    <b-badge v-show="oferta.visada" variant="info"> &laquo;Visada&raquo; {{ fechaVisada }} </b-badge>
    <b-badge v-show="oferta.entregada" variant="warning"> &laquo;Entregada&raquo; {{ fechaEntregada }} </b-badge>
    <b-badge v-show="oferta.borrador" variant="secondary"> &laquo;Borrador&raquo; {{ fechaCreada }} </b-badge>
    <b-badge v-show="oferta.caducada" variant="dark"> &laquo;Caducada&raquo; {{ fechaCaducada }} </b-badge>
    <b-badge v-show="contrato" variant="warning" class="vam p-2 mt-2 text-uppercase"> Con contrato </b-badge>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  computed: mapState(useOfertaFormStore, [
    "oferta",
    "fechaGanada",
    "fechaPerdida",
    "fechaEntregada",
    "fechaVisada",
    "fechaCreada",
    "fechaCaducada",
    "contrato",
  ]),
};
</script>
